module.exports = "/images/banner-02.jpg?3a8bb43a8fd61eceb19b019760eee756";